export default __webpack_public_path__ + "static/media/home-preview.870c0c85.png";